(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mk-contact-email]').forEach((button) => {
  if (button.dataset.mykidssReady === 'true') return;
  button.dataset.mykidssReady = 'true';

  const codes = [105,110,102,111,64,109,121,107,105,100,115,115,46,99,111,109];
  const address = codes.map((code) => String.fromCharCode(code)).join('');
  const label = button.querySelector('[data-mk-contact-email-text]');

  if (label) label.textContent = 'info [at] mykidss.com';

  button.addEventListener('click', () => {
    window.location.href = 'mailto:' + address;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mykidss-home-brands"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBrands(root){
    if(!root||root.dataset.mkBrandsReady==='true')return;
    root.dataset.mkBrandsReady='true';
    var track=root.querySelector('[data-mk-brand-track]');
    if(!track)return;
    var prev=root.querySelector('[data-mk-brand-prev]'),next=root.querySelector('[data-mk-brand-next]');
    function update(){root.classList.toggle('is-scrollable',track.scrollWidth>track.clientWidth+4);}
    function move(direction){track.scrollBy({left:Math.max(track.clientWidth*.72,320)*direction,behavior:'smooth'});}
    if(prev)prev.addEventListener('click',function(){move(-1);});
    if(next)next.addEventListener('click',function(){move(1);});
    window.addEventListener('resize',update,{passive:true});update();
  }
  function init(scope){(scope||document).querySelectorAll('[data-mk-brands]').forEach(initBrands);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mykidss-home-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHero(root){
    if(!root || root.dataset.mkHeroReady === 'true') return;
    root.dataset.mkHeroReady = 'true';
    var track=root.querySelector('[data-mk-hero-track]');
    var slides=Array.prototype.slice.call(track?track.querySelectorAll('.mk-home__hero-slide'):[]);
    if(!track||!slides.length)return;
    var current=0,raf=null;
    function setState(index){current=Math.max(0,Math.min(index,slides.length-1));}
    function go(index){var next=Math.max(0,Math.min(index,slides.length-1));track.scrollTo({left:slides[next].offsetLeft-track.offsetLeft,behavior:'smooth'});setState(next);}
    function detect(){var left=track.getBoundingClientRect().left,best=0,dist=Infinity;slides.forEach(function(slide,i){var d=Math.abs(slide.getBoundingClientRect().left-left);if(d<dist){dist=d;best=i;}});setState(best);}
    track.addEventListener('scroll',function(){if(raf)cancelAnimationFrame(raf);raf=requestAnimationFrame(detect);},{passive:true});
    var prev=root.querySelector('[data-mk-hero-prev]'),next=root.querySelector('[data-mk-hero-next]');
    if(prev)prev.addEventListener('click',function(){go(current>0?current-1:slides.length-1);});
    if(next)next.addEventListener('click',function(){go(current<slides.length-1?current+1:0);});
    track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(current<slides.length-1?current+1:0);}if(e.key==='ArrowLeft'){e.preventDefault();go(current>0?current-1:slides.length-1);}});
  }
  function init(scope){(scope||document).querySelectorAll('[data-mk-hero]').forEach(initHero);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mykidss-home-premium"]) return;
  try {
    
(function(){
  function initHero(root){
    if(!root || root.dataset.mkHeroReady === 'true') return;
    root.dataset.mkHeroReady = 'true';
    var track = root.querySelector('[data-mk-hero-track]');
    var slides = Array.prototype.slice.call(track ? track.querySelectorAll('.mk-home__hero-slide') : []);
    if(!track || !slides.length) return;
    var current = 0;
    var raf = null;
    var counter = root.querySelector('[data-mk-hero-current]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mk-hero-dot]'));

    function setState(index){
      current = Math.max(0, Math.min(index, slides.length - 1));
      if(counter) counter.textContent = String(current + 1).padStart(2, '0');
      dots.forEach(function(dot, i){
        var active = i === current;
        dot.classList.toggle('is-active', active);
        if(active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function go(index){
      var next = Math.max(0, Math.min(index, slides.length - 1));
      var left = slides[next].offsetLeft - track.offsetLeft;
      track.scrollTo({left:left, behavior:'smooth'});
      setState(next);
    }

    function detect(){
      var trackLeft = track.getBoundingClientRect().left;
      var bestIndex = 0;
      var bestDistance = Infinity;
      slides.forEach(function(slide, i){
        var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if(distance < bestDistance){
          bestDistance = distance;
          bestIndex = i;
        }
      });
      setState(bestIndex);
    }

    track.addEventListener('scroll', function(){
      if(raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(detect);
    }, {passive:true});

    var prev = root.querySelector('[data-mk-hero-prev]');
    var next = root.querySelector('[data-mk-hero-next]');
    if(prev) prev.addEventListener('click', function(){ go(current > 0 ? current - 1 : slides.length - 1); });
    if(next) next.addEventListener('click', function(){ go(current < slides.length - 1 ? current + 1 : 0); });
    dots.forEach(function(dot, i){ dot.addEventListener('click', function(){ go(i); }); });
    track.addEventListener('keydown', function(event){
      if(event.key === 'ArrowRight'){ event.preventDefault(); go(current < slides.length - 1 ? current + 1 : 0); }
      if(event.key === 'ArrowLeft'){ event.preventDefault(); go(current > 0 ? current - 1 : slides.length - 1); }
    });
    setState(0);
  }

  function initBrands(root){
    if(!root || root.dataset.mkBrandsReady === 'true') return;
    root.dataset.mkBrandsReady = 'true';
    var track = root.querySelector('[data-mk-brand-track]');
    var prev = root.querySelector('[data-mk-brand-prev]');
    var next = root.querySelector('[data-mk-brand-next]');
    if(!track) return;

    function update(){
      root.classList.toggle('is-scrollable', track.scrollWidth > track.clientWidth + 4);
    }

    function move(direction){
      var distance = Math.max(track.clientWidth * .72, 320);
      track.scrollBy({left: distance * direction, behavior:'smooth'});
    }

    if(prev) prev.addEventListener('click', function(){ move(-1); });
    if(next) next.addEventListener('click', function(){ move(1); });
    window.addEventListener('resize', update, {passive:true});
    update();
  }

  function initAll(scope){
    (scope || document).querySelectorAll('[data-mk-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-mk-brands]').forEach(initBrands);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function(event){ initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
